module.exports = __webpack_public_path__ + "static/logo-36835e814f715944129c4fd74e318844.svg";